
function LimitManagement() {

  let limitManagement = [
    {
      name: "Limit Management",
      icon: "Limit Management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "limitmanagement",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/limit-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const withdrawLimit = () => {
    const profileArr = [
      {
        path: "/index/withdraw-limit",
        name: "WithDraw Limit",
        icon: "WithDraw Limit",
        logoName: "withdraw limit",
        flag: "WITHDRAW LIMIT",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const userWithdrawLimit = () => {
    const mybanksArr = [
      {
        path: "/index/user-withdraw-limit",
        name: "User Withdraw Limit",
        icon: "User Withdraw Limit",
        logoName: "user wirthdraw limit1",
        flag: "USER WITHDRAW LIMIT",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const loadLimit = () => {
    const mycardsArr = [
      {
        path: "/index/load-limit",
        name: "Load Limit",
        icon: "Load Limit",
        logoName: "load limit",
        flag: "LOAD LIMIT",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  let a = dashboard();
  let b = withdrawLimit();
  let c = userWithdrawLimit();
  let d = loadLimit();

  // limitManagement[0].items = [...a, ...b, ...c, ...d, ...e];

  limitManagement[0].items = [...a, ...b, ...c, ...d];

  return limitManagement;
}

export default LimitManagement;
